
import { useCallback } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Product } from "@/types/product";
import { scrollToTop } from "@/utils/scrollUtils";

interface RelatedProductsProps {
  currentProductId: string;
  products: Product[];
}

export default function RelatedProducts({
  currentProductId,
  products
}: RelatedProductsProps) {
  const otherProducts = products.filter(p => p.id !== currentProductId);
  
  const handleProductClick = useCallback(() => {
    scrollToTop();
  }, []);

  return (
    <section className="mb-12 relative">
      <h2 className="text-2xl font-bold mb-6">Other Products</h2>
      <Carousel 
        className="relative"
        opts={{
          loop: true,
          align: "start"
        }}
      >
        <CarouselContent>
          {otherProducts.map(product => (
            <CarouselItem key={product.id} className="md:basis-1/3 lg:basis-1/4">
              <div className="p-2">
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 transition-all duration-200 hover:shadow-md p-4">
                  <img 
                    src={product.images[0]} 
                    alt={`${product.name} exports | Premium Components`} 
                    className="w-full h-48 object-cover rounded-lg mb-4" 
                    loading="lazy" 
                  />
                  <h3 className="mb-2 text-center text-base font-normal">{product.name}</h3>
                  <Link 
                    to={`/products/${product.id}`} 
                    onClick={handleProductClick}
                  >
                    <Button variant="outline" className="w-full">
                      View Details
                    </Button>
                  </Link>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="left-0 -translate-x-1/2" />
        <CarouselNext className="right-0 translate-x-1/2" />
      </Carousel>
    </section>
  );
}
